export default __webpack_public_path__ + "static/media/logo.aa797780.svg";